<template>
  <div id="ContactRent">
    <Hero src="../assets/aboutUs/hero.jpg">
      <h1>Fiksuokite žemą elektros kainą net 5 metams į priekį</h1>
      <h2 class="subtitle">
        Verslams, sunaudojantiems nuo 100 000 kWh per metus
      </h2>
    </Hero>
    <div class="goToFormContrainer">
      <Route class="Btn arrow scrollToForm" :to="{ hash: '#susisiekite-verslui' }">
        Nemokama konsultacija
      </Route>
    </div>
    <Sect class="SectionHowItWorks">
      <Row>
        <Column class="leftSide" :md="6">
          <Wrap class="sm">
            <h2>Kodėl verta rinktis saulės parko nuomą?</h2>
            <ul class="whyWorth">
              <li>Fiksuota elektros kaina 5 metams – jokių staigmenų</li>
              <li>Žemesnė kaina nei elektros biržoje</li>
              <li>Jokios papildomos maržos ar paslėptų mokesčių</li>
              <li>Itin paprasta – tiesiog pasirašote sutartį ir naudojatės žalia energija</li>
            </ul>
            <p>Pasirinkdami saulės parko nuomą, ne tik naudojatės žalia energija, bet ir fiksuojate mažesnę elektros kainą, padedančią reikšmingai sutaupyti.</p>
          </Wrap>
        </Column>
        <Column class="rightSide" :md="6" />
      </Row>
    </Sect>
    <div id="susisiekite-verslui">
      <div class="header">
        <h2><strong>Paskaičiuokime, kiek galite sutaupyti!</strong></h2>
      </div>
      <FormContactNew
        slot="form"
        contactType="business-rent"
        eventLabel="contact-business-rent"
        :fields="[
          'firstName',
          'lastName',
          'email',
          'phone',
          'comment',
        ]" />
    </div>
    <Sect class="sectionContacts">
      <!-- <Wrap class="md">
        <p class="text">
          Arba kviečiame susisiekti su mumis tiesiogiai:
        </p>
      </Wrap> -->
      <Wrap class="contacts-wrap">
        <Row class="contacts">
          <div class="contactItem">
            Tel. nr.: <Phone number="+370 633 82 277" />
          </div>
          <div class="contactItem">
            El. paštas: <Email address="info@saulesbendruomene.lt" />
          </div>
        </Row>
      </Wrap>
    </Sect>
  </div>
</template>

<script>
import FormContactNew from './components/forms/FormContactNew'
import Hero from './components/landing/Hero'
import Meta from './mixins/Meta'

export default {
  mixins: [
    Meta(
      'Susisiekite',
      'Nori prisijungti prie SAULĖS BENDRUOMENĖS? Susisiekite su mumis. Užpildyk žemiau esančią formą arba kreipkis tiesiai į mūsų pardavimų vadybininkus ir mes atsakysime į visus Tau kylančius klausimus. Jokių įsipareigojimų, jokių išankstinių mokėjimų.',
      require('@/assets/social/contact.jpg'),
    ),
  ],
  components: { Hero, FormContactNew },
}
</script>

<style lang="scss">
/* stylelint-disable plugin/stylelint-no-indistinguishable-colors */
$_purple-gradient: linear-gradient(#3d7ae5, #6133d3, #6030d1);

#ContactRent {
  background: $white-ter;
  @include maxMd {
    #Footer {
      background-image: $_purple-gradient;
    }
  }

  ul.whyWorth {
    list-style-position: inside;
    margin-left: 0;
    padding-left: 0;

    li {
      font-size: $h4;
      line-height: 1.5;
      padding-bottom: 1rem;
    }
  }

  .Hero {
    @include roundSvg('../assets/ellipse.svg');

    &::before {
      height: 4rem;
      @include lg {
        height: 6rem;
      }
      @include xxl {
        height: 8rem;
      }
    }

    .Hero-body {
      padding-top: $h1;
    }

    h1 {
      @include dotBefore(8rem);
      padding-bottom: 2rem;
      @include md {
        padding-bottom: 0;
      }
    }

    img {
      filter: brightness(0.2);
    }
  }

  .sectionContacts {
    padding-bottom: 4rem;
    position: relative;
    text-align: center;
    // @include lg {
    //   padding-bottom: 10rem;
    // }

    p {
      font-size: $h3;
      margin-bottom: 2rem;
    }
  }

  .Wrap.contacts-wrap {
    max-width: 850px;
    padding-bottom: 4rem;
    // @include md {
    //   padding-bottom: 6rem;
    // }

    .Row.contacts {
      align-items: center;
      display: flex;
      flex-direction: column;
      font-size: $h3;
      gap: 2rem;
      justify-content: center;
      line-height: $h4;
      @include lg {
        font-size: $h3;
        line-height: $lh;
      }

      .contactItem {
        line-height: $lh * 1.2;
        text-align: center;
      }

      a {
        margin: 0 1rem;
      }
    }
  }

  #susisiekite-verslui {
    margin-top: 3rem;
    @include lg {
      margin-top: 0;
    }

    .header {
      text-align: center;
      width: 100;
    }
  }

  #FormContact {
    a, label {
      color: $white;
    }
  }

  .goToFormContrainer {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;

    > a {
      font-size: 1rem;
      width: 24rem;

    }
  }

  .Sect.SectionHowItWorks {
    color: $white;

    // .Btn {
    //   border: 1px solid $white;
    //   color: $white;
    // }

    > .Row {
      flex-direction: row;

      > .Column {
        display: flex;
        padding: 5rem 1rem;

        > .Wrap {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          justify-content: space-between;
        }
      }
    }

    .rightSide {
      background: url('../assets/business-rent/solar-energy.jpg');
      background-position: top right;
      background-size: cover;
      color: $white;
      min-height: 20rem;
      // padding: 3rem 0 1rem;
      position: relative;
    }

    .leftSide {
      background: $black-bis;
      background-size: 40vw;
      padding: 0 2rem;

      ul.whyWorth {
        list-style-position: inside;
        margin-left: 0;
        padding-left: 0;

        li {
          font-size: $h4;
          line-height: 1.5;
          padding-bottom: 1rem;
        }
      }

      p {
        font-size: $h4;
        line-height: 1.5;
      }
    }

    h2 {
      color: inherit;
      text-align: left;
      // font-size: 1rem;
      // @include lg {
      //   font-size: 3rem;
      // }
    }
  }
}
</style>
